export default __webpack_public_path__ + "static/media/mx_ad_banner_mobile.7ccad714.jpg";